import React from "react";
import { Dialog } from "@headlessui/react";
import Button from "../../../ui/Button";

interface PrintBarcodeOrBatchModalProps {
  manufacturedProductId: any;
  setOpen?: (open: any) => void;
  getManufacturedProductLabel?: (id: any) => void;
  printProductionCostReport?: () => void;
  getProductionBatchReport?: (id: any) => void;
  getLabelCheckReport?: (id: any) => void;
  getVacuumPackReport?: (id: any) => void;
  getCookingAndCoolingReport?: (id: any) => void;
  getMetalDetectorReport?: (id: any) => void;
  openNitrateAndPhosphateCalculator?: () => void;
  getCookingAndDryingReport?: (id: any) => void;
}

export default function PrintBarcodeOrBatchModal(
  props: PrintBarcodeOrBatchModalProps,
) {
  const {
    manufacturedProductId,
    getManufacturedProductLabel,
    printProductionCostReport,
    getProductionBatchReport,
    getLabelCheckReport,
    getVacuumPackReport,
    getCookingAndCoolingReport,
    getMetalDetectorReport,
    openNitrateAndPhosphateCalculator,
  } = props;

  return (
    <div>
      <div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-base font-semibold leading-6 text-gray-900"
          >
            What would you like to print?
          </Dialog.Title>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button
          variant="secondary"
          fullWidth
          className="mt-3 sm:col-start-1 sm:mt-0"
          onClick={() => getProductionBatchReport?.(manufacturedProductId)}
        >
          Production Batch Report
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="mt-3 sm:col-start-1 sm:mt-0"
          onClick={() => getManufacturedProductLabel?.(manufacturedProductId)}
        >
          Production Tag
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="mt-3 sm:col-start-1 sm:mt-0"
          onClick={() => openNitrateAndPhosphateCalculator?.()}
        >
          Nitrate & Phosphate Report
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="mt-3 sm:col-start-1 sm:mt-0"
          onClick={() => getCookingAndCoolingReport?.(manufacturedProductId)}
        >
          Cooking & Cooling
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="mt-3 sm:col-start-1 sm:mt-0"
          onClick={() => getLabelCheckReport?.(manufacturedProductId)}
        >
          Fermentation Record
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="sm:col-start-2"
          onClick={() => getLabelCheckReport?.(manufacturedProductId)}
        >
          Label Check Report
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="sm:col-start-2"
          onClick={() => getVacuumPackReport?.(manufacturedProductId)}
        >
          Vacuum Pack
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="sm:col-start-2"
          onClick={() => getMetalDetectorReport?.(manufacturedProductId)}
        >
          Metal Detector
        </Button>
        <Button
          variant="secondary"
          fullWidth
          className="sm:col-start-2"
          onClick={() => printProductionCostReport?.()}
        >
          Production Cost Report
        </Button>
      </div>
    </div>
  );
}
